<template>
	<div class="add-product">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:visible.sync="dialogProduct"
			width="850px"
			top="5vh"
			custom-class="addproductclass"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<template #title>
				<div class="title_header">
					<span>
						{{
							product.id ? $t("addProduct.edit") : $t("addProduct.add")
						}}</span
					>
					<el-button
						v-if="!fromLibrary"
						style="margin-left: 15px"
						type="primary"
						size="mini"
						@click="chooseLibrary"
						>{{ $t("product.AddProduct.947601-0") }}</el-button
					>
				</div>
			</template>
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="product"
					label-width="80px"
					:model="product">
					<!-- 基础设置 -->
					<el-row :gutter="20">
						{{ $t("product.AddProduct.976199-0") }}
					</el-row>
					<template>
						<el-row :gutter="20">
							<el-col :span="8" v-if="fromMaterial != '1'">
								<el-form-item
									:label="$t('addProduct.productTypeId')"
									prop="typeId">
									<el-select
										v-model="product.typeId"
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										filterable
										:placeholder="$t('addProduct.pProductTypeId')">
										<el-option
											v-for="item in machineType"
											:key="item.id"
											:label="item.name"
											:value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('addProduct.goodsName')" prop="name">
									<el-input
										v-model="product.name"
										:placeholder="$t('addProduct.pProductName')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
							<!-- 素材库只存名称、图片、描述、详情：没有价格，不显示也不校验 -->
							<el-col :span="8" v-if="fromMaterial != '1'">
								<el-form-item :label="$t('addProduct.price')" prop="costPrice">
									<el-input
										v-model="product.costPrice"
										:placeholder="$t('addProduct.pPrice')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item
									:label="$t('addProduct.image')"
									prop="url"
									style="margin-bottom: 0">
									<media-upload
											v-model="product.url"
											:action="uploadUrl"
											accept=".jpg,.jpeg,.png,.gif"
											:image-max-size="1" />
									</el-form-item>
							</el-col>
						</el-row>
					</template>
					<el-row :gutter="20" style="margin-top: 20px; margin-bottom: 10px">
						<span>{{ $t("product.AddProduct.976199-1") }}</span>
						<template> </template>
						<el-button
							style="margin-left: 10px"
							type="primary"
							round
							size="mini"
							v-if="!isExpand"
							@click="isExpand = true"
							>{{ $t("product.AddProduct.976199-2") }}</el-button
						>
						<el-button
							style="margin-left: 10px"
							type="success"
							round
							size="mini"
							v-else
							@click="isExpand = false"
							>{{ $t("product.AddProduct.976199-3") }}</el-button
						>
					</el-row>
					<template v-if="isExpand">
						<el-row :gutter="20">
							<el-col :span="8" v-if="fromMaterial != '1'">
								<el-form-item :label="$t('addProduct.tag')" prop="goodsTags">
									<el-select
										v-model="product.goodsTags"
										multiple
										collapse-tags
										:placeholder="$t('common.select')">
										<el-option
											v-for="item in productTags"
											:key="item.id"
											:label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8" v-if="fromMaterial != '1'">
								<el-form-item :label="$t('addProduct.code')" prop="no">
									<el-input
										v-model="product.no"
										maxlength="11"
										show-word-limit
										:placeholder="$t('addProduct.pCode')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item :label="$t('addProduct.describe')" prop="content">
									<el-input
										v-model="product.content"
										type="textarea"
										:rows="4"
										:placeholder="$t('addProduct.pDescribe')"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item
									:label="$t('addProduct.introduction')"
									prop="introduction">
									<el-tiptap
										@onInit="onInit"
										@onUpdate="onUpdate"
										v-model="product.introduction"
										maxlength="5"
										:extensions="extensions"
										:lang="
											this.$i18n.locale == 'zh_CN'
												? 'zh'
												: this.$i18n.locale == 'en_US'
												? 'en'
												: 'en'
										"
										:size="3" />
									<div
										class="el-upload__tip"
										style="color: red; margin-top: 15px; text-align: right;">
										{{ $t("addProduct.chaoguo") }}
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</template>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('product')"
					>{{
						fromMaterial === "1"
							? $t("product.AddProduct.537115-0")
							: $t("common.definite")
					}}</el-button
				>
			</div>
		</el-dialog>
		<add-product-type
			v-on:cancel="cancelCreate"
			:productType="productType"
			:dialogProductType="dialogProductType">
		</add-product-type>
		<!-- 图书馆 -->
		<el-dialog
			:visible.sync="showLibrary"
			@open="openLibrary"
			@close="showLibrary = false"
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('product.AddProduct.255561-0')"
			:close-on-click-modal="false">
			<div class="search">
				<el-input
					style="width: 150px"
					size="small"
					v-model="search.name"
					:placeholder="$t('product.AddProduct.947601-1')"
					@keyup.enter="searchLibrary"></el-input>
				<el-button size="small" type="primary" @click="searchLibrary">{{
					$t("product.AddProduct.947601-2")
				}}</el-button>
			</div>
			<div class="vue-padding" style="margin-top: 10px">
				<el-table
					v-loading="loading"
					:empty-text="$t('common.noData')"
					:element-loading-text="$t('common.loading')"
					:data="tableList"
					style="width: 100%"
					max-height="638"
					:border="true">
					<el-table-column
						prop="name"
						:show-overflow-tooltip="true"
						:label="$t('product.AddProduct.947601-1')"
						:align="'center'"></el-table-column>
					<el-table-column
						prop="image"
						:label="$t('product.AddProduct.947601-3')"
						:align="'center'">
						<template slot-scope="scope">
							<el-image
								:src="scope.row.url"
								fit="contain"
								style="width: 50px; height: 50px"></el-image>
						</template>
					</el-table-column>
					<el-table-column
						:label="$t('product.AddProduct.947601-4')"
						:align="'center'"
						fixed="right">
						<template slot-scope="scope">
							<el-button
								style="margin: 3px"
								size="mini"
								type="success"
								@click="getLibrary(scope.row)"
								>{{ $t("product.AddProduct.947601-5") }}</el-button
							>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					v-if="tableList.length > 0"
					background
					layout="prev, pager, next"
					:current-page="page.pageIndex"
					:total="page.totalSize"
					:page-size="page.pageSize"
					@current-change="currentChange"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="showLibrary = false">{{
					$t("common.cancel")
				}}</el-button>
			</div></el-dialog
		>
	</div>
</template>

<script>
import config from "@/http/config";
import addProductType from "_c/product/AddProductType";
import mediaUpload from "_c/common/MediaUpload";
import {
	// 需要的 extensions
	Doc,
	Text,
	Paragraph,
	Heading,
	Bold,
	Underline,
	Italic,
	Strike,
	ListItem,
	BulletList,
	OrderedList,
	Link,
	Image,
	CodeBlock,
	Blockquote,
	TodoItem,
	TodoList,
	TextAlign,
	FontSize,
	FontType,
	Fullscreen,
	TextHighlight,
	TextColor,
	FormatClear,
	Table,
	TableHeader,
	TableCell,
	TableRow,
	History,
	TrailingNode,
	HardBreak,
	HorizontalRule,
	LineHeight,
	Indent,
} from "element-tiptap";
export default {
	name: "AddProduct",
	components: {
		addProductType,
		mediaUpload,
	},
	props: {
		product: Object,
		dialogProduct: Boolean,
		productTags: Array,
		fromMaterial: {
			type: String,
			default: "0",
		},
		fromLibrary: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isExpand: false,
			productType: {},
			dialogProductType: false,
			labelPosition: "top",
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addProduct.pProductName"),
						trigger: "blur",
					},
				],
				costPrice: [
					{
						required: true,
						message: this.$t("addProduct.pPrice"),
						trigger: "blur",
					},
					{
						pattern: /^\d+(\.\d{0,2})?$/,
						message: this.$t("addProduct.rPrice"),
					},
				],
				url: [
					{
						required: true,
						message: this.$t("addProduct.pImage"),
						trigger: "change",
					},
				],
			},
			machineType: [],
			fileList: [],
			clear: false,
			uploadUrl: config.baseUrl + this.$url.Upload.product,
			sdUploadUrl: config.baseUrl + this.$url.Upload.sdfile,
			headers: {
				token: this.$cookies.get("token"),
			},
			loadingForm: false,
			extensions: this.getExtensions(),
			length: 0,
			showLibrary: false,
			search: {
				name: "",
			},
			useSearch: {},
			tableList: [],
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			loading: false,
		};
	},
	methods: {
		getExtensions() {
			let that = this;
			return [
				new Doc(), // 必须项
				new Text({
					length: 20,
				}), // 必须项
				new Paragraph(), // 必须项
				new Heading({ level: 6 }), // 标题
				new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
				new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
				new Italic({ bubble: true }), // 斜体
				new Strike({ bubble: true }), // 删除线
				new ListItem(), // 使用列表必须项
				new BulletList({ bubble: true }), // 无序列表
				new OrderedList({ bubble: true }), // 有序列表
				new Link(), // 链接
				new Image({
					// 默认会把图片生成 base64 字符串和内容存储在一起，如果需要自定义图片上传
					// 自定义图片上传(默认会把图片生成base64字符串和内容存储到一起)
					// 图片的上传方法，返回一个 Promise<url>
					async uploadRequest(file) {
						// 如果接口要求 Content-Type 是 multipart/form-data，则请求体必须使用 FormData
						const formdata = new FormData();
						//  image是后台接口需要参数名
						formdata.append("file", file);
						//  调用接口进行上传,拿到服务器返回的图片地址
						const res = await that.$api.request(
							that.$url.common.upload,
							that.$method.post,
							formdata
						);

						if (res.code === 0) {
							return res.data;
						}
						that.$message.warning(res.msg);
						return false;
					},
				}), // 图片
				new CodeBlock({ bubble: true }), // 代码块
				new Blockquote(), // 引用
				new TodoItem(), // 任务列表必须项
				new TodoList(), // 任务列表
				new TextAlign({ bubble: true }), // 文本对齐方式
				new FontSize({ bubble: true }), // 字号
				new FontType({ bubble: true }), // 字体
				new Fullscreen(), // 全屏
				new TextHighlight({ bubble: true }), // 文本高亮
				new TextColor({ bubble: true }), // 文本颜色
				new FormatClear({ bubble: true }), // 清除格式
				new Table({ resizable: true }), // 表格
				new TableHeader(), // 表格必须项
				new TableCell(), // 表格必须项
				new TableRow(), // 表格必须项
				new History(), // 撤销
				new TrailingNode(), // 重做
				new HardBreak(), // 分割线
				new HorizontalRule(), // 行距
				new LineHeight(), // 增加缩进
				new Indent(), // 减少缩进
			];
		},
		handlerCreateProductType() {
			console.log(this.$t("product.AddProduct.537115-1"));
			this.dialogProductType = true;
		},
		cancelCreate() {
			this.dialogProductType = false;
			this.getProductType();
		},
		onInit({ editor }) {
			console.log(editor);
		},
		onUpdate(editor) {
			var content = editor.replace(/<.*?>/g, "");
			this.length = content.length;
		},
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		submitForm(formName) {
			if (this.length > 5000) {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("addProduct.chaoguo"),
					type: "error",
				});
				return false;
			}
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.Product.insert;
					let method = this.$method.post;
					if (this.product.id) {
						url = this.$url.Product.update;
						method = this.$method.put;
					}
					// 素材库商品：有 id 走更新，否则新增
					if (this.fromMaterial === "1") {
						url = this.product.id ? this.$url.ProductLibrary.update : this.$url.ProductLibrary.insert;
						method = this.product.id ? this.$method.put : this.$method.post;
					}
					let arr = [];
					if (this.product.goodsTags) {
						console.log(this.product.goodsTags);
						this.product.goodsTags.forEach(key => {
							let obj = { goodsTagId: key };
							arr.push(obj);
						});
					}
					this.product.goodsTags = arr;
					this.$api
						.request(url, method, this.product)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.clear = true;
								this.cancel(this.product.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
							this.loadingForm = false;
						});
				}
			});
		},
		closeDialog() {
			this.clearValidate("product");
			this.machineType = [];
			if (this.product.id) {
				this.$toolUtil.clearForm(this.product);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.product);
				}
			}
			this.cancel("");
		},
		openDialog() {
			console.log("product", this.product);
			this.fileList = [];
			if (this.product.url) {
				this.fileList.push({ name: "uploaded_image", url: this.product.url });
			}
			// 获取商品类型
			this.getProductType();
			let arr = [];
			if (this.product.goodsTags) {
				this.product.goodsTags.forEach(key => {
					arr.push(key.goodsTagId);
				});
			}
			this.product.goodsTags = arr;
			// 节约性能 执行一次
			if (this.fromMaterial != "1") {
				this.currentChange();
			}
		},
		getProductType() {
			this.$api
				.request(this.$url.ProductType.list, this.$method.get, {
					goodsId: this.product.id,
				})
				.then(res => {
					if (res.code === 0) {
						this.machineType = res.data;
					}
				});
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
		//  商品缩略图上传
		handleImageError(err) {
			this.$message.error(err.msg ? err.msg : this.$t("addProduct.error"));
			return false;
		},
		handleImageRemove() {
			this.product.url = "";
			this.handleShowUpload();
		},
		beforImageUpload(file) {
			const isJPGPNG = file.type === "image/jpeg" || file.type === "image/png";
			const isLt1M = file.size / 1024 / 1024 < 1;
			if (!isJPGPNG) {
				this.$message.error(this.$t("addProduct.imagexzgs"));
			}
			if (!isLt1M) {
				this.$message.error(this.$t("addProduct.imagexzdx"));
			}
			this.handleHideUpload();
			return isJPGPNG && isLt1M;
		},
		handleImageSuccess(res) {
			if (res.code === 0) {
				this.product.url = res.data;
			} else {
				this.$message.warning(res.msg);
			}
		},
		handleHideUpload() {
			this.$nextTick(() => {
				let card = window.document.querySelector(".el-upload--picture-card");
				card.style.display = "none";
			});
		},
		handleShowUpload() {
			let _self = this;
			let djs = setTimeout(function () {
				clearTimeout(djs);
				_self.$nextTick(() => {
					let card = window.document.querySelector(".el-upload--picture-card");
					card.style.display = "block";
				});
			}, 1000);
		},
		// 选择素材
		chooseLibrary() {
			this.showLibrary = true;
		},
		searchLibrary() {
			this.currentChange(1, true);
		},
		currentChange(pageIndex, isSearch) {
			console.log(isSearch, 11231);
			if (isSearch) {
				this.useSearch = JSON.parse(JSON.stringify(this.search));
			}
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.useSearch, this.page);
			this.$api
				.request(this.$url.ProductLibrary.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.tableList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		getLibrary(row) {
			Object.keys(this.product).forEach(key => {
				if (key === "id") return;
				this.product[key] = row[key];
			});
			this.showLibrary = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.el-upload-list--picture-card .el-upload-list__item {
	margin: 0;
}
.quill-editor editor {
	height: 600px !important;
}
.ql-container ql-snow {
	height: 480px !important;
}
.addproductclass .el-dialog__header {
	padding: 20px;
}
.addproductclass .el-dialog__body {
	padding: 0 20px 10px 20px !important;
	margin: 0 !important;
	height: auto;
}
.addproductclass .el-dialog__footer {
	padding: 0 20px 20px 20px;
}
.addproductclass .el-form--label-top .el-form-item__label {
	padding-bottom: 0;
}
.addproductclass .el-form-item {
	margin-bottom: 15px;
}
.title_header {
	line-height: 24px;
	font-size: 18px;
	color: var(--vtm-ink);
	display: flex;
	align-items: center;
}
.search {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
}
::v-deep .el-dialog__body {
	height: auto;
}
</style>
